import React from 'react'
import {Link} from 'gatsby'
import styled, {css} from 'styled-components'
import {down, up} from 'styled-breakpoints'
import {
  FaBars, FaTimes, FaAngleDown, FaAngleUp,
} from 'react-icons/fa'
import is from 'styled-is'

import {withOuterWrapper, omitProps} from '~/hocs'
import {colors} from '~/constants/style'

const contentPadding = css`
  padding-left: 100px;
  padding-right: 100px;

  ${down('sm')} {
    padding-left: 15px;
    padding-right: 15px;
  }
`

const Header = styled.div``

Header.ContactAndSocialLinksWrapper = styled.div`
  background: ${colors.darkBg};
  padding-top: 5px;
  padding-bottom: 5px;
  ${contentPadding}

  a {
    color: white;

    &:hover {
      text-decoration: none;
      color: ${colors.green};
    }
  }
`

Header.ContactAndSocialLinks = styled(
  withOuterWrapper(Header.ContactAndSocialLinksWrapper)('div'),
)`
  display: flex;
  justify-content: space-between;
`

Header.Contact = styled.div`
  display: flex;
  align-items: center;

  ${down('sm')} {
    width: 100%;
    justify-content: space-between;
    padding-top: 5px;
    padding-bottom: 5px;
  }
`

Header.ContactItem = styled.a`
  &:not(:last-child) {
    margin-right: 20px;
  }
`

Header.ContactItemIcon = styled.span`
  margin-right: 10px;
`

Header.ContactItemValue = styled.span``

Header.SocialLinks = styled.div`
  ${down('sm')} {
    display: none;
  }
`

Header.SocialLinkItem = styled.a`
  height: 40px;
  width: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

Header.LogoAndNavAndContactUsWrapper = styled.div`
  ${contentPadding}
  background: white;

  ${down('sm')} {
    padding-top: 15px;
    padding-bottom: 15px;
  }
`

Header.LogoAndNavAndContactUs = styled(
  withOuterWrapper(Header.LogoAndNavAndContactUsWrapper)('div'),
)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const navHeight = '90'
const logoPadding = '15'

Header.LogoWrapper = styled(Link)`
  height: ${navHeight - logoPadding * 2}px;
  margin-right: 20px;
`

Header.Logo = styled.img`
  height: 100%;
`

Header.NavAndContactUs = styled.div`
  display: flex;
  align-items: center;
`

Header.NavWrapper = styled.div`
  margin-right: 20px;

  ${down('sm')} {
    display: none;
    z-index: 2;
    padding-top: ${navHeight}px;

    ${is('show')`
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin-right: 0;
      background: white;
    `}
  }
`

Header.Nav = styled(
  withOuterWrapper(Header.NavWrapper, 'show')(
    omitProps('show')('div'),
  ),
)`
  display: flex;

  ${down('sm')} {
    display: block;
    width: 100%;
  }
`

Header.NavItemsLv2Wrapper1 = styled.div`
  display: none;

  ${up('md')} {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 250px;
  }
`

Header.NavItemsLv2Wrapper = styled(
  withOuterWrapper(Header.NavItemsLv2Wrapper1)('div'),
)`
  ${up('md')} {
    position: absolute;
    top: 0;
    left: 0;
  }
`

const itemHeight = '40px'

Header.NavItemLv2 = styled(Link)`
  display: flex;
  align-items: center;
  line-height: ${itemHeight};
  padding-left: 12px;
  padding-right: 12px;
  background: white;
  color: #000;
  font-weight: 600;

  &:hover {
    text-decoration: none;
    color: white;
    background: ${colors.darkBg};
  }

  ${down('sm')} {
    display: block;
    text-align: center;
    background: #e1e2e2;
  }
`

Header.NavItem = styled.div`
  ${({hasChildren}) => hasChildren && css`
    position: relative;
    z-index: 1;

    ${up('md')} {
      &:hover ${Header.NavItemsLv2Wrapper1} {
        display: block;
      }
    }

    ${down('sm')} {
      ${({showSubMenu}) => showSubMenu && css`
        ${Header.NavItemsLv2Wrapper1} {
          display: block;
        }
      `}
    }
  `}
`

Header.Arrow = styled.div.attrs((props) => ({
  children: props.showSubMenu ? <FaAngleUp /> : <FaAngleDown />,
}))`
  height: ${itemHeight};
  width: ${itemHeight};
  color: white;
  background: ${colors.green};
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
`

Header.NavLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  height: ${navHeight}px;
  padding-left: 12px;
  padding-right: 12px;
  color: #000;
  font-weight: 600;

  &:hover, &.active {
    text-decoration: none;
    color: white;
    background: ${colors.darkBg};
  }

  ${down('sm')} {
    display: block;
    height: unset;
    line-height: ${itemHeight};
    text-align: center;
  }
`

Header.ContactUs = styled.a`
  border: 1px solid ${colors.green};
  color: ${colors.green};
  padding: 5px 15px;

  &:hover {
    text-decoration: none;
    color: white;
    background: ${colors.green};
  }

  ${down('sm')} {
    display: none;
  }
`

Header.NavToggler = styled(FaBars).attrs({className: 'd-md-none'})`
  font-size: 2.5rem;
`

Header.CloseNavBtnWrapper = styled.div.attrs({className: 'd-md-none'})`
  height: ${navHeight}px;
  width: ${navHeight}px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
`

Header.CloseNavBtn = styled(
  withOuterWrapper(Header.CloseNavBtnWrapper, 'onClick')(FaTimes),
)`
  font-size: 2.2rem;
`

Header.Banner = styled.div`
  background: url('https://res.cloudinary.com/ngabds/image/upload/f_auto,q_auto/v1617419894/static-images/header_ffrrii.png') no-repeat center / cover;
  padding-top: 45.5050505%;
`

export default Header
